class MineralObject {
  name = null;
  cleavage = null;
  composition = null;
  crystal = null;
  density = null;
  formula = null;
  fracture = null;
  hardness = null;
  lustre = null;
  streak = null;
  type = null;
  img = null;

  #dictionary = null;

  constructor(targetLanguage, dictionary, mineral, sourceLanguage = null) {
    (this.targetLanguage = targetLanguage),
      (this.sourceLanguage = sourceLanguage),
      (this.#dictionary = dictionary),
      (this.givenName =
        this.targetLanguage === "en" ? mineral : this.#dictionary[mineral]),
      (this.idName = this.#removeAccent(mineral.name));
    this.name = this.targetLanguage === "en" ? mineral.name : mineral.pt_name;
    this.cleavage =
      this.targetLanguage === "en"
        ? { propName: "cleavage", propValue: mineral.cleavage }
        : {
            propName: this.#dictionary["cleavage"],
            propValue: this.translateString(mineral.cleavage),
          };
    this.composition =
      this.targetLanguage === "en"
        ? { propName: "composition", propValue: mineral.composition }
        : {
            propName: this.#dictionary["composition"],
            propValue: this.#dictionary[mineral.composition],
          };
    this.crystal =
      this.targetLanguage === "en"
        ? { propName: "crystal system", propValue: mineral.crystal_system }
        : {
            propName: this.#dictionary["crystal system"],
            propValue: this.#dictionary[mineral.crystal_system],
          };
    this.density =
      this.targetLanguage === "en"
        ? {
            propName: "density",
            propValue: [mineral.density_min, mineral.density_max],
          }
        : {
            propName: this.#dictionary["density"],
            propValue: [
              this.#convertNumberFormat(mineral.density_min),
              this.#convertNumberFormat(mineral.density_max),
            ],
          };
    this.fracture =
      this.targetLanguage === "en"
        ? { propName: "fracture", propValue: mineral.fracture }
        : {
            propName: this.#dictionary["fracture"],
            propValue: this.translateString(mineral.fracture),
          };
    (this.hardness =
      this.targetLanguage === "en"
        ? {
            propName: "hardness",
            propValue: [mineral.hardness_min, mineral.hardness_max],
          }
        : {
            propName: this.#dictionary["hardness"],
            propValue: [
              this.#convertNumberFormat(mineral.hardness_min),
              this.#convertNumberFormat(mineral.hardness_max),
            ],
          }),
      (this.lustre =
        this.targetLanguage === "en"
          ? { propName: "lustre", propValue: mineral.lustre }
          : {
              propName: this.#dictionary["lustre"],
              propValue: this.translateString(mineral.lustre),
            });
    this.streak =
      this.targetLanguage === "en"
        ? { propName: "streak", propValue: mineral.streak }
        : {
            propName: this.#dictionary["streak"],
            propValue: mineral.pt_streak,
          };
    this.formula =
      this.targetLanguage === "en"
        ? { propName: "formule", propValue: mineral.symbol_1 }
        : { propName: "fórmula", propValue: mineral.symbol_1 };
    this.type =
      this.targetLanguage === "en"
        ? { propName: "type", propValue: mineral.type }
        : {
            propName: this.#dictionary["type"],
            propValue: this.#dictionary[mineral.type],
          };
    this.img = {
      link: mineral.img_url,
      author: mineral.img_author,
      authorLink: mineral.img_aut_url,
      license: mineral.img_license,
      alt: mineral.img_alt,
      mindatLink: mineral.img_mindat,
    };
  }

  #convertNumberFormat(num) {
    const nf = new Intl.NumberFormat("pt-BR", {
      style: "decimal",
      maximumFractionDigits: 2,
    });
    return nf.format(num);
  }

  #removeAccent(str) {
    return str
      .normalize("NFD")
      .replace(/([\u0300-\u036f]|[^a-zA-Z])|\W/g, "")
      .toLowerCase();
  }

  translateString(originalString) {
    // convert string into lowercase
    if (!originalString) return;
    const stringConvertedtToLowercase = originalString.toLowerCase();
    const eachWord = /\b[a-z]+/gi;
    // create an array comprising each word of the string
    const dictEntries = [...stringConvertedtToLowercase.matchAll(eachWord)];
    // translate the string
    const translatedString = dictEntries.reduce((total, word) => {
      return (total = total.replace(word, this.#dictionary[word]));
    }, stringConvertedtToLowercase);
    return translatedString;
  }

  // matchFromEnglish(mineral) {
  //   const collator = new Intl.Collator("en", {
  //     usage: "search",
  //     sensitivity: "base",
  //   });

  //   let match;
  //   match = this.#data.find(
  //     (dat) => collator.compare(dat["name"], mineral) === 0,
  //   );

  //   return match.name;
  // }

  // matchFromPortuguese(mineral) {
  //   const collator = new Intl.Collator("pt", {
  //     usage: "search",
  //     sensitivity: "base",
  //   });

  //   let match;
  //   match = this.#data.find(
  //     (dat) => collator.compare(dat["pt_name"], mineral) === 0,
  //   );
  //   // if (!match)
  //   //   match = this.#data.find(
  //   //     (dat) => collator.compare(dat["name"], mineral) === 0,
  //   //   );

  //   this.getProperties(match);

  //   return match.name;
  // }
  // getProperties(match) {
  //   const nf = new Intl.NumberFormat("pt-BR", {
  //     style: "decimal",
  //     maximumFractionDigits: 2,
  //   });
  // this.name = this.targetLanguage === "en" ? match.name : match.pt_name;
  // this.cleavage =
  //   this.targetLanguage === "en"
  //     ? { propName: "cleavage", propValue: match.cleavage }
  //     : {
  //         propName: this.#dictionary["cleavage"],
  //         propValue: this.translateString(match.cleavage),
  //       };
  // this.composition =
  //   this.targetLanguage === "en"
  //     ? { propName: "composition", propValue: match.composition }
  //     : {
  //         propName: this.#dictionary["composition"],
  //         propValue: this.#dictionary[match.composition],
  //       };
  // this.crystal =
  //   this.targetLanguage === "en"
  //     ? { propName: "crystal system", propValue: match.crystal_system }
  //     : {
  //         propName: this.#dictionary["crystal system"],
  //         propValue: this.#dictionary[match.crystal_system],
  //       };
  // this.density =
  //   this.targetLanguage === "en"
  //     ? {
  //         propName: "density",
  //         propValue: [match.density_min, match.density_max],
  //       }
  //     : {
  //         propName: this.#dictionary["density"],
  //         propValue: [
  //           nf.format(match.density_min),
  //           nf.format(match.density_max),
  //         ],
  //       };
  // this.fracture =
  //   this.targetLanguage === "en"
  //     ? { propName: "fracture", propValue: match.fracture }
  //     : {
  //         propName: this.#dictionary["fracture"],
  //         propValue: this.translateString(match.fracture),
  //       };
  // this.hardness = [
  //   this.targetLanguage === "en"
  //     ? {
  //         propName: "hardness",
  //         propValue: [match.hardness_min, match.hardness_max],
  //       }
  //     : {
  //         propName: this.#dictionary["hardness"],
  //         propValue: [
  //           nf.format(match.hardness_min),
  //           nf.format(match.hardness_max),
  //         ],
  //       },
  // ];
  // this.lustre =
  //   this.targetLanguage === "en"
  //     ? { propName: "lustre", propValue: match.lustre }
  //     : {
  //         propName: this.#dictionary["lustre"],
  //         propValue: this.translateString(match.lustre),
  //       };
  // this.streak =
  //   this.targetLanguage === "en"
  //     ? { propName: "streak", propValue: match.streak }
  //     : {
  //         propName: this.#dictionary["streak"],
  //         propValue: this.#dictionary[match.streak],
  //       };
  // this.formula =
  //   this.targetLanguage === "en"
  //     ? { propName: "formule", propValue: match.symbol_1 }
  //     : { propName: "fórmula", propValue: match.symbol_1 };
  // this.type =
  //   this.targetLanguage === "en"
  //     ? { propName: "type", propValue: match.type }
  //     : {
  //         propName: this.#dictionary["type"],
  //         propValue: this.#dictionary[match.type],
  //       };
  // this.img = `./img/photos/${match.name}_large.webp`;
  // this.img_url = match.img_url;
  // this.img_author = match.img_author;
  // this.img_aut_url = match.img_aut_url;
  // this.img_license = match.img_license;
  // (this.img_alt = match.img_alt), (this.img_mindat = match.img_mindat);
  // }
}

export { MineralObject };
